export default __webpack_public_path__ + "static/media/info_start.min.fca34a20.png";